import React from 'react'
import { GetServerSideProps } from 'next'

import { API } from '../../../../revelry_api'
import { Case, FuneralHome, LifePageNavItem } from '../../../../types'
import FourOFour from '../../../../components/pages/FourOFour'
import { FuneralHomeFooter } from '../../../../components/FuneralHomeFooter'
import LifePageLayout from '../../../../components/LifePageLayout'
import Obituary from '../../../../components/models/Obituary'
import ObituaryMeta from '../../../../components/ObituaryMeta'
import ServicesPage from '../../../../components/pages/ServicesPage'
import { routes } from '../../../../routes'
import useSetBackgroundColor from '../../../../hooks/useSetBackgroundColor'

interface Props {
  funeralHome: FuneralHome | null
  theCase: Case | null
}

const ObituaryServicesPage: React.FC<Props> = ({ funeralHome, theCase }) => {
  useSetBackgroundColor('#f0f0f0')

  if (!theCase || !funeralHome) {
    return <FourOFour />
  }

  const pageTitle = `${Obituary.deceasedFullName(theCase)} Services - ${funeralHome.name}`
  const pageDescription = `See service information for ${Obituary.deceasedFullName(
    theCase,
  )}. View funeral service information, upload memories & photos, and send condolences or flowers.`

  return (
    <>
      <ObituaryMeta
        obituary={theCase}
        funeralHome={funeralHome}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        canonicalPath={routes.services(theCase)}
      />

      <LifePageLayout activeNavItem={LifePageNavItem.SERVICES} obituary={theCase}>
        <ServicesPage theCase={theCase} timeZone={funeralHome.time_zone} />
      </LifePageLayout>

      <FuneralHomeFooter />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (req) => {
  try {
    const slugArray = (req.params.slug as string).split('-')
    const obituaryID = slugArray[slugArray.length - 1]
    const [funeralHome, theCase] = await Promise.all([
      API.funeralHomes.load(),
      API.cases.load(obituaryID),
    ])

    return { props: { funeralHome, theCase } }
  } catch (e) {
    return { props: { funeralHome: null, theCase: null } }
  }
}

export default ObituaryServicesPage
